import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../config/editor-environment';
import { AuthService } from '../services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class MaintenanceGuard implements CanActivate {
  private router = inject(Router);
  private http = inject(HttpClient);
  private authService = inject(AuthService);

  canActivate(): Observable<boolean> {
    if (this.authService.isAdmin()) {
      return of(true);
    }

    return this.http.get<{ enabled: boolean }>(`${environment.API_ADDRESS}/maintenance/status`).pipe(
      map((status) => {
        if (status.enabled) {
          this.router.navigate(['/maintenance']);
          return false;
        }
        return true;
      }),
      catchError(() => of(true)),
    );
  }
}
